@if (orders$ | async; as orders) {
  @if (!noOrders) {
    <div class="container">
      <div class="cx-order-history-body">
        <div class="cx-order-history-top top cx-order-history-controls row align-items-center">
          <div class="cx-order-history-form-group col-sm-12 col-md-6 col-lg-12 col-xl-3">
            <button class="btn btn-primary btn-small mr-2 my-1" (click)="onDownloadCSV()">
              <i [class]="downloadSpinner ? 'fa fa-spinner fa-spin' : 'fa fa-download'"></i>
              {{ 'orderHistory.downloadCSV' | cxTranslate }}
            </button>
          </div>
          <div class="cx-order-history-form-group form-group col-sm-12 col-md-6 col-lg-3 col-xl-3">
            {{ 'orderHistory.search' | cxTranslate }}
            <div class="input-group">
              <input
                type="text"
                class="form-control search-input"
                id="searchOrder"
                [ngClass]="{ roundCorner: !inputSearch }"
                [(ngModel)]="inputSearch"
                (keydown.enter)="searchOrder($event.target.value)"
                [title]="'orderHistory.searchHint' | cxTranslate"
                [placeholder]="'orderHistory.searchHint' | cxTranslate"
                />
                <div class="input-group-append">
                  @if (inputSearch) {
                    <span class="input-group-text" (click)="inputSearch = null; searchOrder(null)">
                      <i class="fa fa-times"></i>
                    </span>
                  }
                </div>
              </div>
            </div>
            <div class="cx-order-history-form-group form-group col-sm-12 col-md-12 col-lg-3 col-xl-2">
              {{ 'orderHistory.lineStatusFilter' | cxTranslate }}:
              <ng-select
                (change)="getFilteredLineOrders($event)"
                class="cx-order-history-top__filter"
                [(ngModel)]="selectedLineFilter"
                [clearOnBackspace]="false"
                placeholder="{{ 'orderHistory.filterOrderLines' | cxTranslate }}"
                >
                @for (itemFilter of linestatusFilters; track itemFilter) {
                  <ng-option [value]="itemFilter">
                    {{ 'orderDetails.statusDisplay' | cxTranslate: { context: itemFilter } }}
                  </ng-option>
                }
              </ng-select>
            </div>
            <div class="cx-order-history-form-group form-group col-sm-12 col-md-12 col-lg-3 col-xl-2">
              {{ 'orderHistory.filterBy' | cxTranslate }}:
              <ng-select
                (change)="getFilteredOrders($event)"
                class="cx-order-history-top__filter"
                [(ngModel)]="selectedFilter"
                [clearOnBackspace]="false"
                placeholder="Filter Orders"
                >
                @for (itemFilter of filters; track itemFilter) {
                  <ng-option [value]="itemFilter">
                    {{ 'orderDetails.statusDisplay' | cxTranslate: { context: itemFilter } }}
                  </ng-option>
                }
              </ng-select>
            </div>
            <div class="cx-order-history-form-group form-group col-sm-12 col-md-12 col-lg-3 col-xl-2">
              {{ 'orderHistory.sortBy' | cxTranslate }}:
              <cx-sorting
                class="cx-order-history-top__sort"
                [sortOptions]="orders?.sorts"
                [sortLabels]="getSortLabels() | async"
                (sortListEvent)="changeSortCode($event)"
                [selectedOption]="orders?.pagination?.sort"
                placeholder="{{ 'orderHistory.sortByMostRecent' | cxTranslate }}"
              ></cx-sorting>
            </div>
          </div>
          <table class="table order-history-table">
            <thead class="cx-order-history-thead-mobile">
              <th scope="col">{{ 'orderHistory.orderId' | cxTranslate }}</th>
              <th scope="col">{{ 'orderHistory.orderDate' | cxTranslate }}</th>
              <th scope="col">{{ 'orderHistory.purchaseOrderNumber' | cxTranslate }}</th>
              <th scope="col">{{ 'orderHistory.status' | cxTranslate }}</th>
              <th scope="col">{{ 'orderHistory.total' | cxTranslate }}</th>
              <th scope="col">{{ 'orderHistory.actions' | cxTranslate }}</th>
            </thead>
            @if (orders?.pagination?.totalResults > 0 || selectedFilter) {
              <tbody>
                @for (order of orders.orders; track order) {
                  <tr>
                    <td class="cx-order-history-code">
                      <div class="d-md-none cx-order-history-label">
                        {{ 'orderHistory.orderId' | cxTranslate }}
                      </div>
                      <p (click)="detailViewClicked(order.code)">
                        <a [routerLink]="{ cxRoute: 'orderDetails', params: order } | cxUrl" class="cx-order-history-value">
                          {{ order?.code }}</a
                          >
                        </p>
                      </td>
                      <td class="cx-order-history-placed">
                        <div class="d-md-none cx-order-history-label">
                          {{ 'orderHistory.orderDate' | cxTranslate }}
                        </div>
                        <p class="cx-order-history-value">{{ order?.placed | cxDate: 'longDate' }}</p>
                      </td>
                      <td class="order-history-purchase-order">
                        <div class="d-md-none cx-order-history-label">
                          {{ 'orderHistory.purchaseOrderNumber' | cxTranslate }}
                        </div>
                        <p class="cx-order-history-value">{{ order?.purchaseOrderNumber }}</p>
                      </td>
                      <td class="cx-order-history-status">
                        <div class="d-md-none cx-order-history-label">
                          {{ 'orderHistory.status' | cxTranslate }}
                        </div>
                        <p class="cx-order-history-value">
                          <app-order-status [order]="order"></app-order-status>
                        </p>
                      </td>
                      <td class="cx-order-history-total">
                        <div class="d-md-none cx-order-history-label">
                          {{ 'orderHistory.total' | cxTranslate }}
                        </div>
                        <p class="cx-order-history-value">{{ order?.total.formattedValue }}</p>
                      </td>
                      <td class="cx-order-history-links">
                        @if (!showSpinnerOnReorder(order?.code)) {
                          <button
                            class="btn btn--small"
                            [matMenuTriggerFor]="menu"
                            >
                            <i class="fa fa-ellipsis-v" aria-hidden="true" aria-label="menu"></i>
                          </button>
                        } @else {
                          <div class="action-loader">
                            <i class="fa fa-spinner fa-spin"></i>
                          </div>
                        }
                        <mat-menu #menu="matMenu">
                          @if (order?.orderDocumentsNumber && userPermissionService.invoicesAndCreditNotes) {
                            <div>
                              @for (orderDocument of order?.orderDocumentsNumber; track orderDocument) {
                                <div
                                  mat-menu-item
                                  (click)="onDocumentClicked(orderDocument)"
                                  >
                                  <span
                                    ><i [ngClass]="spinner ? 'fa-spinner fa-spin' : 'fa-download'" class="fa menu__icon"></i>
                                    {{ 'orderHistory.download' | cxTranslate }}
                                    <span class="menu__document">{{ orderDocument?.documentType }}</span></span
                                    >
                                  </div>
                                }
                              </div>
                            }
                            <div mat-menu-item (click)="orderAgain(order?.code)">
                              <span
                                ><i aria-hidden="true" class="fa fa-redo menu__icon"></i>
                                {{ 'orderHistory.orderAgain' | cxTranslate }}</span
                                >
                              </div>
                              @if (checkSubmitClaim(order)) {
                                <div>
                                  @if (checkCreditClaim(order?.orderDocumentsNumber)) {
                                    <div mat-menu-item>
                                      <span
                                        [routerLink]="{ cxRoute: 'createCreditClaimOrder', params: { orderCode: order?.code } } | cxUrl"
                                        ><i class="menu__icon fas fa-money-check"></i>
                                        {{ 'orderHistory.submitClaim' | cxTranslate }}</span
                                        >
                                      </div>
                                    }
                                  </div>
                                }
                                <div mat-menu-item (click)="detailViewClicked(order.code)">
                                  <span [routerLink]="{ cxRoute: 'orderDetails', params: order } | cxUrl"
                                    ><i class="fa menu__icon fa-info-circle"></i>
                                    {{ 'orderHistory.viewOrderDetails' | cxTranslate }}</span
                                    >
                                  </div>
                                </mat-menu>
                              </td>
                            </tr>
                          }
                        </tbody>
                      }
                    </table>
                    <div class="pagination-container">
                      <cx-pagination [pagination]="orders?.pagination" (viewPageEvent)="pageChange($event + 1)"></cx-pagination>
                    </div>
                  </div>
                </div>
              }
            }

            <!-- spinner -->
            @if (showSpinnerOnDataLoad) {
              <div class="cx-spinner">
                <cx-spinner></cx-spinner>
              </div>
            }


            @if (noOrders) {
              <div class="cx-order-history-no-order row">
                <div class="col-sm-12 col-md-6 col-lg-4">
                  <div>{{ 'orderHistory.noOrders' | cxTranslate }}</div>
                  <a [routerLink]="{ cxRoute: 'home' } | cxUrl" routerLinkActive="active" class="btn btn-primary btn-block">{{
                    'orderHistory.startShopping' | cxTranslate
                  }}</a>
                </div>
              </div>
            }
